<template>
  <div class="column-key-map-wrapper">
    <label class="inline-block" style="width:48%;">CRM Key
      <span class="shortcode-select-wrapper" v-if="fieldKeys && fieldKeys.length" @click="fieldkeySelectActive = !fieldkeySelectActive">
        <i class="fa fa-caret-down"></i>
        <small v-if="fieldkeyCopied" class="text-success">Copied!</small>
        <ul v-if="fieldkeySelectActive" class="shortcode-select list-group">
          <li class="list-group-item"
              v-for="field_key in fieldKeys"
              @click="copyToClipboard(field_key)"
          >{{field_key}}</li>
        </ul>
      </span>
    </label>
    <label class="inline-block">
      Value
      <span class="shortcode-select-wrapper" v-if="leadTableColumns && leadTableColumns.length" @click="shortcodesSelectActive = !shortcodesSelectActive">
        <i class="fa fa-caret-down"></i>
        <small v-if="shortcodeCopied" class="text-success">Copied!</small>
        <ul v-if="shortcodesSelectActive" class="shortcode-select list-group">
          <li class="list-group-item"
              v-for="column in leadTableColumns"
              @click="copyShortcode(column)"
          >{{column}}</li>
        </ul>
      </span>
    </label>
    <repeatable-input v-model="localValue" :proto="[
          {
            key: '',
            value: ''
          }
        ]">
      <template v-slot:default="{ row, rowIndex }">
        <input data-form-type="other" :data-w-input="`static-key-${rowIndex}`" type="text" placeholder="crm field key" class="w-full border border-gray-200 rounded focus:border-green-500 focus:ring-transparent" v-model="row.key">
        <span style="font-size:1.5em;"> = </span>
        <input data-form-type="other" :data-w-input="`static-value-${rowIndex}`" type="text" placeholder="crm field key" class="w-full border border-gray-200 rounded focus:border-green-500 focus:ring-transparent" v-model="row.value">
      </template>
    </repeatable-input>
  </div>
</template>

<script>
  export default{
    props:{
      value: {required: true},
      fieldKeys: {type: Array},
      leadTableColumns: {type: Array, default:()=>{
          return []
        }},
    },
    data(){
      return {
        fieldkeySelectActive: false,
        fieldkeyCopied: false,
        shortcodesSelectActive: false,
        shortcodeCopied: false
      }
    },
    computed:{
      localValue:{
        get(){
          return this.value
        },
        set(value){
          this.$dispatch("input", value)
        }
      }
    },
    methods:{
      copyToClipboard(fieldkey){
        this.fieldkeyCopied = true;
        this.$copyText(`${fieldkey}`)
        setTimeout(()=>{this.fieldkeyCopied = false}, 1500)
      },
      copyShortcode(column){
        this.shortcodeCopied = true;
        this.$copyText(`{{${column}}}`)
        setTimeout(()=>{this.shortcodeCopied = false}, 1500)
      }
    }
  }
</script>

<style scoped lang="scss">
  label{
    font-size:.8rem;
  }
  .shortcode-select-wrapper{
    position:relative;
  }
  .shortcode-select{
    position:absolute;
    z-index: 3;
    top:100%;
    left:0;
    max-height:250px;
    overflow:scroll;
    box-shadow:0 0 1px 1px rgba(0,0,0,.15);
    li{
      &:hover{
        color:white;
        background: #82bc00;
      }
    }
  }
</style>
